import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StellingScore} from '../../../../domain/game';
import {STELLINGSET} from '../../../game-data';

@Component({
  selector: 'sg-stelling-content',
  templateUrl: './stelling-content.component.html',
  styleUrls: ['./stelling-content.component.scss']
})

export class StellingContentComponent implements OnInit {

  @Input() randomStelling: number;
  @Output() stellingContentChange = new EventEmitter<StellingScore>();
  stellingSet = STELLINGSET;
  // randomStelling = 0;

  stellingScoreObj: StellingScore = null;
  gekozenStellingScoreOpties = ['oneens', 'onbeslist', 'eens'];
  gekozenStellingScore: string;
  gekozenScore1 = false;
  gekozenScore2 = false;
  gekozenScore3 = false;


  ngOnInit(): void {
    // this.randomStelling = (Math.floor(Math.random() * this.stellingSet.length));
  }

  closePopover() {
    this.stellingContentChange.emit(null);
  }

  kiesScore(i) {
    this.gekozenStellingScore = this.gekozenStellingScoreOpties[i - 1];

    if (i === 1) {
      this.gekozenScore1 = true;
      this.gekozenScore2 = false;
      this.gekozenScore3 = false;
    }
    ;
    if (i === 2) {
      this.gekozenScore1 = false;
      this.gekozenScore2 = true;
      this.gekozenScore3 = false;
    }
    ;
    if (i === 3) {
      this.gekozenScore1 = false;
      this.gekozenScore2 = false;
      this.gekozenScore3 = true;
    }
    ;
  }

  saveStellingScore() {
    this.stellingScoreObj = {stellingID: this.randomStelling, stellingScore: this.gekozenStellingScore};
    this.stellingContentChange.emit(this.stellingScoreObj);
  }
}
